export default function _mountView ({view, params, transition, content, scrollPosition}) {
  return {type: 'MOUNT_ROUTED_VIEW', payload: {view, params, transition, content, scrollPosition}};
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/_mountView.js